// `/campaigns/$id` — detail route (US-123..US-138 except create).

import { createRoute, useNavigate } from '@tanstack/react-router';

import { CampaignDetailPage } from '@/features/campaigns/CampaignDetailPage';

import { Route as CampaignsLayoutRoute } from './__layout';

export const Route = createRoute({
  getParentRoute: () => CampaignsLayoutRoute,
  path: '$id',
  component: CampaignDetailRoute,
});

function CampaignDetailRoute() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  return (
    <CampaignDetailPage
      id={id}
      onBack={() => {
        void navigate({ to: '/campaigns' });
      }}
      onReconnect={() => {
        void navigate({ to: '/accounts' });
      }}
    />
  );
}
